var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoubleCheck = function SvgDoubleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.517 4.553a.72.72 0 0 0-.51.231l-6.48 6.459c-.192.191-.384.178-.533-.046L2.95 9.646a.73.73 0 0 0-1.017-.208.73.73 0 0 0-.21 1.018l1.042 1.55c.668 1.003 1.974 1.13 2.825.28l6.458-6.46a.735.735 0 0 0 0-1.042.77.77 0 0 0-.532-.23m4.166 0a.75.75 0 0 0-.532.208s-7.664 7.644-7.755 7.71c.702.516 1.658.495 2.338-.186l6.482-6.458a.763.763 0 0 0 0-1.066.75.75 0 0 0-.533-.208"
  })));
};
export default SvgDoubleCheck;